import React from 'react';
import { Link } from 'react-router-dom';

const Error503 = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-gray-900 mb-4">503</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Service Unavailable</h2>
          <p className="text-gray-600 mb-8">
            The server is temporarily unable to service your request due to maintenance downtime or capacity problems.
          </p>
          <Link 
            to="/dashboard"
            className="px-6 py-3 bg-[#0E4B4B] text-white rounded-md hover:bg-[#126F6F] focus:outline-none focus:ring-2 focus:ring-[#0E4B4B] focus:ring-offset-2 transition-colors duration-200"
          >
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error503;
